import { ViewBooking } from "collins-js-sdk";
import React, { useMemo } from "react";
import { VenueConfig } from "../../../../../../../types/venues";
import { getBookingAssignedAreaNamesAsString } from "../../../../../../../utils/singleBooking";
import {
  getUniqueZoneNames,
  renderTruncatedTables
} from "../utils/bookingCardTableAndZoneUtils";

interface DiaryBookingCardTableAndZoneInfoProps {
  isOnRunSheet?: boolean;
  booking: ViewBooking;
  venueConfig: VenueConfig;
}

export const DiaryBookingCardTableAndZoneInfo =
  React.memo<DiaryBookingCardTableAndZoneInfoProps>(
    ({ isOnRunSheet, booking, venueConfig }) => {
      // Compute booking assigned areas
      const bookingAssignedAreasAsString = useMemo(
        () => getBookingAssignedAreaNamesAsString(booking),
        [booking.assignedAreas, booking.id]
      );

      // Compute zone information
      const { uniqueZoneNames, zoneNamesFormatted } = useMemo(
        () => getUniqueZoneNames(booking, venueConfig),
        [booking.assignedAreas, booking.id, venueConfig?.bookable_area_zones]
      );

      if (isOnRunSheet) {
        return null;
      }

      return (
        <div className="DiarySidebarListRow Row2">
          <div className="DiarySidebarListItem__detailsTable">
            <span className="DiarySidebarListItem__detailsTable_View">
              {renderTruncatedTables(bookingAssignedAreasAsString)}
            </span>
          </div>
          <div className="DiarySidebarListItem__auxZone">
            <span className="DiarySidebarListItem__auxZone_View">
              {uniqueZoneNames.length > 1
                ? zoneNamesFormatted
                : uniqueZoneNames}
            </span>
          </div>
        </div>
      );
    }
  );

DiaryBookingCardTableAndZoneInfo.displayName =
  "DiaryBookingCardTableAndZoneInfo";
